import { Grid, Typography } from "@mui/material";
import { SimpleSelect } from "../Form";

const TitleWSelect = ({ handleChange, title, options, year, label = 'Año' }) => {
    return(
        <Grid container spacing={3} sx={{ mb: '2em' }}>
            <Grid item xs={12} sm={12} md={10}>
                <Typography variant="h5">{title}</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={2}>
                <SimpleSelect label={label} options={options} onChange={handleChange} val={year} />
            </Grid>
        </Grid>
    )
}

export default TitleWSelect;